import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface CopyIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number | string;
}

const CopyIcon: React.FC<CopyIconProps> = ({ strokeWidth = 3, ...props }) => (
  <SvgIcon {...props} viewBox="0 0 50 50" className="sx-icon-plus">
    <path
      d="M12 12 H32 V32 H12 Z
        M20 20 H40 V40 H20 Z"
      fill="none"
      stroke={props.color || 'currentColor'}
      strokeWidth={strokeWidth}
      strokeLinejoin="miter"
      strokeLinecap="butt"
    />
  </SvgIcon>
);

export default CopyIcon;
